import { Dimensions, Platform, PixelRatio } from "react-native";

const { height, width } = Dimensions.get("screen");

const dpiRatio = PixelRatio.get();

const fonts = {};

if (dpiRatio >= 2 && dpiRatio < 2.5) {
  fonts.head1 = 18;
  fonts.head2 = 18;
  fonts.head3 = 14;
  fonts.content1 = 14;
  fonts.content2 = 13;
  fonts.content3 = 11;
} else if (dpiRatio >= 2.5 && dpiRatio < 3) {
  fonts.head1 = 20;
  fonts.head2 = 19;
  fonts.head3 = 16;
  fonts.content1 = 15;
  fonts.content2 = 13;
  fonts.content3 = 12;
} else if (dpiRatio >= 3 && dpiRatio < 3.5) {
  fonts.head1 = 22;
  fonts.head2 = 19;
  fonts.head3 = 17;
  fonts.content1 = 15;
  fonts.content2 = 14;
  fonts.content3 = 12;
} else {
  fonts.head1 = 24;
  fonts.head2 = 20;
  fonts.head3 = 18;
  fonts.content1 = 16;
  fonts.content2 = 14;
  fonts.content3 = 12;
}

const metrics = {
  margin1: width / 20,
  margin2: width / 25,
  margin3: width / 30,
  margin4: width / 40,
  margin5: width / 50,
  margin6: width / 60,
  margin7: width / 70,
  marginHorizontal: 10,
  marginVertical: 10,
  section: 25,
  baseMargin: 16,
  baseGutter: 15,
  doubleBaseMargin: 20,
  smallMargin: 5,
  doubleSection: 50,
  horizontalLineHeight: 1,
  mainContainerPadding: 15,
  allHeaderPadding: 16,
  cardPadding: 16,
  screenWidth: width < height ? width : height,
  screenHeight: width < height ? height : width,
  borderRound: 50,
  margin: {
    xxs: 6,
    xs: 8,
    sm: 10,
    md: 12,
    bs: 16,
  },
  padding: {
    xxs: 6,
    xs: 8,
    sm: 10,
    md: 12,
    bs: 16,
  },
};

const onboardingImageHeight = () => {
  let h;
  if (height < 600) {
    h = 200;
  } else if (height > 600 && height < 800) {
    h = 280;
  } else {
    h = 340;
  }
  return h;
};

const onboardingBottomLoginHeight = () => {
  let h;
  if (height < 600) {
    h = height * 0.27;
  } else if (height > 600 && height < 800) {
    h = height * 0.25;
  } else {
    h = height * 0.21;
  }
  return h;
};

const onboardingBottomHeight = () => {
  let h;
  if (height < 600) {
    h = height * 0.15;
  } else if (height > 600 && height < 800) {
    h = height * 0.13;
  } else {
    h = height * 0.12;
  }
  return h;
};

const isSmallScreen = height < 600;

const onboardingDimensions = {
  imageHeight: onboardingImageHeight(),
  imageWidth: onboardingImageHeight(),
  bottomContainerLoginHeight: onboardingBottomLoginHeight(),
  bottomContainerHeight: onboardingBottomHeight(),
};

const scale = width / 360;

export const normalize = (size) => {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

export { fonts, onboardingDimensions, isSmallScreen, width, height };

export default metrics;
